import filtersInfo from "@/locales/en.json";

const filters = {
  options: {},
  selected: {},
  categories: {}
};

// Legal problems
// Show all respondents
filters.selected.experiencedLegalProblems = true;
// Focus on one legal problem
filters.selected.focusOnOneLegalProblem = false;
// Problem types
filters.options.legalProblemType = Object.keys(
  filtersInfo.filters.legalProblems.legalProblemType.options
).map(Number);
filters.selected.legalProblemType = filters.options.legalProblemType[0];
// Problems
filters.options.legalProblem = Object.keys(
  filtersInfo.filters.legalProblems.legalProblem.options
).map(Number);
filters.selected.legalProblem = filters.options.legalProblem[0];

// Demographics
filters.categories.demographics = [];
Object.entries(filtersInfo.filters.demographics).forEach(([key, val]) => {
  filters.categories.demographics.push(key);
  filters.options[key] = Object.keys(val.options).map(Number);
  filters.selected[key] = filters.options[key].slice();
});

// Resolutions
filters.categories.resolutions = [];
Object.entries(filtersInfo.filters.resolutions).forEach(([key, val]) => {
  filters.categories.resolutions.push(key);
  filters.options[key] = Object.keys(val.options).map(Number);
  filters.selected[key] = filters.options[key].slice();
});

export default filters;
